import React from 'react';
import { Card } from './ui/card';
import { technicalSkills, strengths } from '../mock';
import { Code, Smartphone, Server, Database, Wrench, Sparkles } from 'lucide-react';

const TechnicalSkills = () => {
  const skillCategories = [
    {
      title: "Mobile",
      icon: Smartphone,
      items: technicalSkills.mobile
    },
    {
      title: "Frontend",
      icon: Code,
      items: technicalSkills.frontend
    },
    {
      title: "Backend",
      icon: Server,
      items: technicalSkills.backend
    },
    {
      title: "Databases",
      icon: Database,
      items: technicalSkills.databases
    },
    {
      title: "Integrations & Tools",
      icon: Wrench,
      items: technicalSkills.tools
    }
  ];

  return (
    <section className="py-24 bg-black text-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-5xl md:text-6xl font-bold mb-4 text-center">
          Technical Skills
        </h2>
        <p className="text-gray-400 text-center mb-16 text-lg">Tools and technologies I work with</p>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {skillCategories.map((category, index) => {
            const Icon = category.icon;
            return (
              <Card 
                key={index}
                className="bg-zinc-900 border-zinc-800 p-6 hover:border-[#E91E63] transition-all duration-300 hover:shadow-[0_0_20px_rgba(233,30,99,0.3)]"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#C2185B] to-[#E91E63] flex items-center justify-center">
                    <Icon className="h-5 w-5 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-white">{category.title}</h3>
                </div>
                <div className="space-y-2">
                  {category.items.map((item, idx) => (
                    <div key={idx} className="flex items-center gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#E91E63]"></div>
                      <span className="text-sm text-gray-300">{item}</span>
                    </div>
                  ))}
                </div>
              </Card>
            );
          })}

          {/* Strengths */}
          <Card className="bg-zinc-900 border-zinc-800 p-6 hover:border-[#E91E63] transition-all duration-300 hover:shadow-[0_0_20px_rgba(233,30,99,0.3)]">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#C2185B] to-[#E91E63] flex items-center justify-center">
                <Sparkles className="h-5 w-5 text-white" />
              </div>
              <h3 className="text-lg font-bold text-white">Strengths</h3>
            </div>
            <div className="space-y-2">
              {strengths.map((item, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-[#E91E63]"></div>
                  <span className="text-sm text-gray-300">{item}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TechnicalSkills;
